import { adminAuthClient, supabase } from './api'
import { getIdData } from './profiles'

/** Full URL for Supabase password recovery redirect (must match Supabase Auth → Redirect URLs). */
export function getPasswordResetRedirectUrl() {
	if (typeof window === 'undefined') return ''
	const pub = (process.env.PUBLIC_URL || '').replace(/\/$/, '')
	return `${window.location.origin}${pub}/newpassword`
}

export async function createUser(email, pass, role) {
	const { data, error } = await adminAuthClient.auth.admin.createUser({
		email: email,
		password: pass,
		email_confirm: true,
		user_metadata: { role: role }
	})
	console.log('error', error)
	return { data, error }
}

export async function updateRole(userId, role) {
	const { data, error } = await adminAuthClient.auth.admin.updateUserById(userId, {
		email_confirm: true,
		user_metadata: { role: role }
	})

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function signIn(user, pass) {
	try {
		const { data, error } = await supabase.auth.signInWithPassword({
			email: user,
			password: pass
		})

		if (error) {
			return { data: null, error }
		}

		const userprofile = await getIdData(data.user.id)
		localStorage.setItem('eplus', JSON.stringify(userprofile))

		return { data, error: null }
	} catch (e) {
		console.error('Beklenmeyen hata:', e.message)
		return { data: null, error: e }
	}
}

export async function forgotPass(email) {
	try {
		const redirectTo = getPasswordResetRedirectUrl()
		const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
			redirectTo: redirectTo || undefined
		})

		if (error) {
			return { data: null, error }
		}

		return { data, error: null }
	} catch (e) {
		console.error('Beklenmeyen hata:', e.message)
		return { data: null, error: e }
	}
}

export async function updateUser(newPassword) {
	let { data, error } = await supabase.auth.updateUser({ password: newPassword })
	return { data, error }
}

export async function getUserId() {
	const { data, error } = await supabase.auth.getSession()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data?.session?.user?.id || null
}

export async function signOut() {
	const { error } = await supabase.auth.signOut()

	localStorage.removeItem('companyId')
	localStorage.clear()
	sessionStorage.clear()

	if (error) {
		throw new Error('Failed to fetch data')
	}
}
